import { Point, Sprite } from 'pixi.js-legacy';
import Textures from '../textures';
export class CenterButtonOptions {
    constructor() {
        this.position = new Point(0, 0);
        this.xDim = 0;
        this.yDim = 0;
        this.onPress = () => { };
    }
}
export class CenterButton extends Sprite {
    constructor(options = new CenterButtonOptions()) {
        super(Textures.getInstance().CenterButton);
        this.name = 'CenterButton';
        this.position.copyFrom(options.position);
        this.width = options.xDim;
        this.height = options.yDim;
        this.onPress = options.onPress;
        this.interactive = true;
        this.buttonMode = true;
        this.on('pointerdown', this.onButtonDown);
    }
    onButtonDown() {
        this.onPress();
    }
}
